import { computed, ref } from "vue";
import { defineStore } from "pinia";

interface NotificationConfigItem {
  type: "success" | "warning" | "error" | "info" | "danger";
  title: string;
  message: string;
}

interface StoredNotificationConfigItem extends NotificationConfigItem {
  key: string;
}

export const useToastNotificationsStore = defineStore(
  "toastNotifications",
  () => {
    // State
    const _visibleNotifications = ref<StoredNotificationConfigItem[]>([]);
    const _errorLocked = ref<boolean>(false);

    // Getters
    const visibleNotifications = computed(() => _visibleNotifications.value);
    const errorLocked = computed(() => _errorLocked.value);

    // Actions
    const addVisibleNotification = (item: StoredNotificationConfigItem) => {
      _visibleNotifications.value.push(item);
    };

    const removeVisibleNotification = (keyToRemove: string) => {
      _visibleNotifications.value = _visibleNotifications.value.filter(
        (visibleNotification) => visibleNotification.key !== keyToRemove,
      );
    };

    const isNotificationVisible = ({
      type,
      title,
      message,
    }: NotificationConfigItem) => {
      return _visibleNotifications.value.some(
        (visibleNotification) =>
          visibleNotification.type === type &&
          visibleNotification.title === title &&
          visibleNotification.message === message,
      );
    };

    const lockError = () => {
      _errorLocked.value = true;
    };

    const unlockError = () => {
      _errorLocked.value = false;
    };

    return {
      visibleNotifications,
      errorLocked,
      addVisibleNotification,
      removeVisibleNotification,
      isNotificationVisible,
      lockError,
      unlockError,
    };
  },
);
